module.exports = __webpack_public_path__ + "img/11.3f8b9e70.jpg";